import CryptoJS from 'crypto-js';
import { JtiGenerator } from './JtiGenerator.js';

/**
 * Codifica un string a Base64URL (RFC 7515)
 */
function toBase64Url(str) {
  const wordArray = CryptoJS.enc.Utf8.parse(str);
  return CryptoJS.enc.Base64.stringify(wordArray).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * Codifica un WordArray de CryptoJS a Base64URL
 */
function wordArrayToBase64Url(wordArray) {
  return CryptoJS.enc.Base64.stringify(wordArray).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * Generador de tokens JWT con firma HMAC-SHA256.
 *
 * Algoritmo: HS256
 * Firma: HMAC-SHA256(base64url(header).base64url(payload), secretKey)
 */
export class ApiKeyAuth {
  static INSTANCE = null;

  constructor() {
    this.clientId = process.env.REACT_APP_CLIENT_ID;
    this.secretKey = process.env.REACT_APP_CLIENT_SECRET_KEY;
    this.serverOffset = 0;
  }

  /**
   * Calibra el reloj local contra el servidor usando el header Date de la respuesta.
   */
  calibrate(serverDateHeader) {
    const serverTime = Math.floor(new Date(serverDateHeader).getTime() / 1000);
    if (!isNaN(serverTime)) {
      this.serverOffset = serverTime - Math.floor(Date.now() / 1000);
    }
  }

  /**
   * Retorna el timestamp actual en segundos, corregido con el offset del servidor.
   */
  now() {
    return Math.floor(Date.now() / 1000) + this.serverOffset;
  }

  static instance() {
    if (ApiKeyAuth.INSTANCE === null) {
      ApiKeyAuth.INSTANCE = new ApiKeyAuth();
    }
    return ApiKeyAuth.INSTANCE;
  }

  /**
   * Genera un token JWT firmado con HS256
   */
  generateToken(options = {}) {
    const header = this.encodeHeader();
    const payload = this.encodePayload(options);
    const signature = this.sign(`${header}.${payload}`);

    return `${header}.${payload}.${signature}`;
  }

  encodeHeader() {
    const header = { alg: 'HS256', typ: 'JWT' };
    return toBase64Url(JSON.stringify(header));
  }

  encodePayload(options = {}) {
    const currentTime = this.now();

    const payload = {
      client_id: this.clientId,
      iat: currentTime,
      jti: JtiGenerator.generate('auth', currentTime),
    };

    if (options.ttl) {
      payload.exp = currentTime + options.ttl;
    }

    return toBase64Url(JSON.stringify(payload));
  }

  sign(data) {
    const signature = CryptoJS.HmacSHA256(data, this.secretKey);
    return wordArrayToBase64Url(signature);
  }

  /**
   * Retorna los headers de autenticación listos para usar
   */
  getHeaders(options = {}) {
    return {
      'X-API-KEY': this.generateToken(options),
      'Content-Type': 'application/json',
    };
  }
}
